module.exports = __webpack_public_path__ + "static/media/1_cipla.5af058d1.svg";